import React from "react";
import useTranslate from "../../hooks/useTranslate";

// Channel pill row — frames 1a (desktop wrap), 1e/1l (mobile: one row that
// scrolls horizontally with a visibly cut-off pill at the edge, never clipped
// silently — 1r), 1n/1p (active pill carries an × to clear).
//
// `active` is the channel slug or null for All. The description line under
// the row belongs to the pills (1a: "All: every channel in one feed.").

const pillBase =
  "shrink-0 whitespace-nowrap rounded-full text-[12.5px] min-[402px]:text-[13px] py-2 px-3.5 min-[402px]:px-[15px] sm:py-1.5 sm:px-3.5 min-h-[36px] sm:min-h-0";

const ChannelPills = ({ channels, active, onSelect, className = "" }) => {
  const { t } = useTranslate();
  const activeChannel = channels.find((c) => c.slug === active) || null;

  return (
    <div className={className}>
      {/* Mobile: horizontal scroll bleeding to the right edge (1e draws the
          row wider than the padding box so the cut pill signals more).
          Desktop: wrap. */}
      <div
        className="flex gap-[7px] min-[402px]:gap-2 overflow-x-auto -mr-3.5 min-[402px]:-mr-4 pr-3.5 min-[402px]:pr-4 sm:flex-wrap sm:overflow-visible sm:mr-0 sm:pr-0"
        style={{ scrollbarWidth: "none" }}
        data-testid="channel-pills"
      >
        <button
          type="button"
          onClick={() => onSelect(null)}
          className={[
            pillBase,
            active === null
              ? "bg-[#2283FF] text-white font-semibold"
              : "bg-white border border-[#DDE3EB] text-[#6B7280] font-medium hover:border-[#C6CFDA]",
          ].join(" ")}
        >
          {t("All")}
        </button>
        {channels.map((channel) => {
          const isActive = channel.slug === active;
          return (
            <button
              key={channel.slug}
              type="button"
              onClick={() => onSelect(isActive ? null : channel.slug)}
              className={[
                pillBase,
                isActive
                  ? "bg-[#2283FF] text-white font-semibold inline-flex items-center gap-[7px]"
                  : "bg-white border border-[#DDE3EB] text-[#6B7280] font-medium hover:border-[#C6CFDA]",
              ].join(" ")}
            >
              {channel.name}
              {isActive && (
                <svg width="11" height="11" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path
                    d="M4.5 4.5l7 7m0-7l-7 7"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </button>
          );
        })}
      </div>
      <p className="m-0 mt-2 min-[402px]:mt-[9px] sm:mt-2.5 text-[12px] min-[402px]:text-[12.5px] sm:text-[13px] text-[#6B7280]">
        <span className="font-semibold text-[#111827]">
          {activeChannel ? activeChannel.name : t("All")}:
        </span>{" "}
        {activeChannel ? activeChannel.description : t("every channel in one feed.")}
      </p>
    </div>
  );
};

export default ChannelPills;
